const ProductIdPerJobType = [9, 11];

export default ProductIdPerJobType;
